import { RECEIVE_IS_PRIORITY, LOYALTY_SDK_FAILURE } from "../constants";
import { receiveIsPriority, loyaltySdkFailure } from "./payloadCreators";

export default {
  [RECEIVE_IS_PRIORITY]: receiveIsPriority,
  [LOYALTY_SDK_FAILURE]: loyaltySdkFailure
};
